<template>
    <v-dialog v-model="isOpen" max-width="400">
        <div class="dialogClose">
            <div v-on:mousedown.prevent="isOpen = false" v-on:touchstart.prevent="isOpen = false"><img
                    src="/images/common/close.png" /></div>
        </div>
        <v-card class="dialogBase dialogMain">
            <v-card-text>
                <div class="text-center dialogHtpTitle windowTitle">{{ $store.getters.setting.mapname }}</div>
                <v-row class="text-center">
                    <v-col cols="12" class="text-center ma-0 pa-0 mb-5 flickArea"
                        v-if="$store.getters.dataMaps.length == 1">
                        <div class="flickdiv" v-for="map in $store.getters.dataMaps" :key="map.image">
                            <div>
                                <pre>{{ map.name }}</pre>
                            </div>
                            <img width="100%" :src="map.image" />
                        </div>
                    </v-col>
                    <v-col cols="12" class="text-center ma-0 pa-0 mb-5 flickArea" v-else>
                        <Flicking :options="{ circular: true }" ref="flick" @move-start="dialogMoveStart"
                            @move-end="dialogMoveEnd">

                            <div class="flickdiv" v-for="map in $store.getters.dataMaps" :key="map.image">
                                <div class="mapName mb-2">
                                    <pre>{{ map.name }}</pre>
                                </div>
                                <img width="100%" :src="map.image" />
                                <div v-for="link in map.link" :key="link.name">
                                    <v-btn :class="link.style" :href="link.url" class="mt-3" target="_blank">
                                        {{ link.name }}
                                    </v-btn>
                                </div>
                            </div>
                        </Flicking>

                        <div id="flickNextBtn" class="flickBtnArea">
                            <img src="/images/puzzle/btn_next.png" @click="flickNext" />
                        </div>
                        <div id="flickPrevBtn" class="flickBtnArea">
                            <img src="/images/puzzle/btn_prev.png" @click="flickPrev" />
                        </div>
                        <div id="flickIcon" class="flickBtnArea flickBtnIcon">
                            <img src="/images/puzzle/flick_icon.png" />
                        </div>

                        <!-- <v-row>
                            <v-col cols="12" class="mb-2 mt-7 pa-0 htpdot">
                                <v-row class="ma-0 pa-0">
                                    <v-col cols="12 text-center" ref="htpdotarea">
                                        <a href="#" @click="dialogFloorGo(0)"><img src="/images/howtoplay/dot_red.png"
                                                ref="htdot1" /></a>
                                        <a href="#" @click="dialogFloorGo(1)"><img src="/images/howtoplay/dot_gray.png"
                                                ref="htdot2" /></a>
                                        <a href="#" @click="dialogFloorGo(2)"><img src="/images/howtoplay/dot_gray.png"
                                                ref="htdot3" /></a>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row> -->
                    </v-col>

                </v-row>

            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<style scoped>
.windowTitle {
    font-size: min(4vw, 1.2em);
    line-height: 1em;
}

.flickdiv {
    width: 100%;
    padding-top: min(3vw, 18px);
    padding-left: min(7vw, 42px);
    padding-right: min(7vw, 42px);
    padding-bottom: min(3vw, 18px);
    font-size: min(5vw, 18px);
}

.flickArea {
    position: relative;
}

.flickBtnArea {
    position: absolute;
    display: flex;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.flickBtnArea img {
    width: min(8vw, 28px);
    margin: min(1vw, 18px);
    z-index: 1;
}

.flickBtnIcon {
    /* margin-top: min(6vw, 30px); */
}

.flickBtnIcon img {
    width: min(8vw, 48px) !important;
    margin-right: min(4vw, 10px);
}


#flickNextBtn {
    justify-content: flex-end;
    align-items: center;
}

#flickPrevBtn {
    justify-content: flex-start;
    align-items: center;
}

#flickIcon {
    justify-content: flex-end;
    align-items: end;
}

.mapName {
    font-family: "Rounded Mplus 1c", sans-serif;
    font-size: min(3.1vw, 0.9em);
    line-height: 1.4em;
    font-weight: bold !important;
    padding-bottom: 0.5em;
    text-align: center;
}

.btn_blue {
    color: #FFFFFF !important;
    background-color: #0F9DE8 !important;
    box-shadow: 4px 3px #096291;
    border-radius: 100vh;
    width: 80%;
    height: 2.3em !important;
    padding-top: min(1vw, 3px) !important;
    text-transform: none !important;
    font-size: min(5vw, 20px) !important;
    font-weight: bold !important;
}

.btn_blue:disabled {
    box-shadow: 4px 3px #999999;
}

.btn_green {
    color: #FFFFFF !important;
    background-color: #4CAF50 !important;
    box-shadow: 4px 3px #357a38;
    border-radius: 100vh;
    width: 80%;
    height: 2.3em !important;
    padding-top: min(1vw, 3px) !important;
    text-transform: none !important;
    font-size: min(5vw, 20px) !important;
    font-weight: bold !important;
}

.btn_green:disabled {
    box-shadow: 4px 3px #999999;
}
</style>
<script>

import '@/assets/style/window.css';

export default {
    data: () => ({
        isOpen: true,
    }),
    props: {
    },
    created: function () {
    },
    destroyed: function () {
    },
    methods: {
        dialogMoveStart(e) {

        },
        dialogMoveEnd(e) {
            setTimeout(() => {
                let nowNum = e.currentTarget.index;
            }, 100);
        },
        flickNext() {
            this.$refs.flick.next();
        },
        flickPrev() {
            this.$refs.flick.prev();
        },

        // dialogFloorGo(num) {
        //     console.log("dialogFloorGo", num);
        //     this.$refs.flick.moveTo(num);
        //     // this.dialogHtpMoveStart({ "eventType": "forceMove", "number": num, "currentTarget": this.$refs.dialogHtpFlick })
        // },
    },
    computed: {

    },
    watch: {
        isOpen(newVal) {
            if (!newVal) {
                this.$emit('close');
            }
        }
    }
}
</script>